import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['status'];

  copyToClipboard = async (ev) => {
    const text = ev.currentTarget.innerHTML;

    try {
      await navigator.clipboard.writeText(text);
      this.showCopySuccess();
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  showCopySuccess() {
    // Find the status element in the support modal
    const statusElement = document.querySelector(
      '[data-support-request-target="status"]'
    );
    if (statusElement) {
      statusElement.classList.remove('visually-hidden');
      setTimeout(() => {
        statusElement.classList.add('visually-hidden');
      }, 2000);
    }
  }
}
